export default __webpack_public_path__ + "static/media/Illustation_search.01a038dc.svg";